import GeoLocalizador from './GeoLocalizador.js'
import CalcDistancia from './CalcDistancia'

const localizarCalcularOrganizar = async (lista, setCarregando) => {
    try {
        let ondeEuTo = await GeoLocalizador()
        const roles = lista.map((item) => {
            const lat = item.coordenadas != null ? item.coordenadas.split(',')[0] : null
            const lon = item.coordenadas != null ? item.coordenadas.split(',')[1] : null
            const distanciaKM = CalcDistancia(ondeEuTo.latitude, ondeEuTo.longitude, lat, lon)
            return { ...item, distancia: parseFloat(distanciaKM)}
        });
        setCarregando(false)
        return roles.sort((a, b) => a.distancia - b.distancia);
    } catch (error) {
        console.error("Erro ao calcular distâncias:", error);
        setCarregando(false)
        return lista.sort((a, b) => (a.subcategoria < b.subcategoria ? -1 : 1));
    }
}

export default localizarCalcularOrganizar